import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import cvData, { CVSection } from "../data/cvData";





const TimelineVertical: React.FC<{ sections: CVSection[] }> = ({ sections }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '32px 0 40px 0', position: 'relative' }}>
    {/* Continuous vertical line behind all points */}
    <div style={{ position: 'absolute', left: 20, top: 0, bottom: 50, width: 2, background: '#b3c9d1', zIndex: 0 }} />
    {sections.filter(s => s.timeline && s.timeline.length > 0).map((section, idx) => (
      <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', position: 'relative', minHeight: 100, marginBottom: 48, zIndex: 1 }}>
        {/* Timeline point */}
        <div style={{ width: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', height: '100%' }}>
          <div style={{ width: 16, height: 16, borderRadius: 8, background: '#2C5F6F', margin: 0, zIndex: 2, border: '3px solid #fff', boxShadow: '0 0 0 2px #2C5F6F', position: 'relative' }} />
        </div>
        {/* Section content */}
        <div style={{ marginLeft: 24, flex: 1, background: '#fafdff', borderRadius: 12, boxShadow: '0 2px 8px rgba(44,95,111,0.04)', padding: '18px 24px', border: '1px solid #eaf6fa' }}>
          <div style={{ fontWeight: 700, fontSize: '1.2em', color: '#2C5F6F', marginBottom: 6 }}>{section.title}</div>
          <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
            {section.items.map((item, i) => {
              return (
                <li key={i} style={{ marginBottom: 16 }}>
                  {/* Timeline label removed as requested */}
                  <div style={{ fontWeight: 600, fontSize: '1.1em' }}>{item.title}{item.institution && `, ${item.institution}`}</div>
                  {item.description && (
                    <>
                      {(item.location || item.date) && (
                        <div style={{ margin: '10px 0 6px 0', display: 'flex', gap: 10 }}>
                          {item.location && (
                            <span style={{
                              background: '#eaf6fa',
                              color: '#2C5F6F',
                              borderRadius: 14,
                              padding: '2px 12px',
                              fontWeight: 600,
                              fontSize: '0.98em',
                              display: 'inline-block',
                              border: '1px solid #d2e7f0',
                            }}>{item.location}</span>
                          )}
                          {item.date && (
                            <span style={{
                              background: '#f5eafc',
                              color: '#7b3fa0',
                              borderRadius: 14,
                              padding: '2px 12px',
                              fontWeight: 600,
                              fontSize: '0.98em',
                              display: 'inline-block',
                              border: '1px solid #e2d2f0',
                            }}>{item.date}</span>
                          )}
                        </div>
                      )}
                      <div style={{ margin: '2px 0 2px 0', color: '#444' }}>{item.description}</div>
                    </>
                  )}
                  {item.details && (
                    <>
                      {!(item.description) && (item.location || item.date) && (
                        <div style={{ margin: '10px 0 6px 0', display: 'flex', gap: 10 }}>
                          {item.location && (
                            <span style={{
                              background: '#eaf6fa',
                              color: '#2C5F6F',
                              borderRadius: 14,
                              padding: '2px 12px',
                              fontWeight: 600,
                              fontSize: '0.98em',
                              display: 'inline-block',
                              border: '1px solid #d2e7f0',
                            }}>{item.location}</span>
                          )}
                          {item.date && (
                            <span style={{
                              background: '#f5eafc',
                              color: '#7b3fa0',
                              borderRadius: 14,
                              padding: '2px 12px',
                              fontWeight: 600,
                              fontSize: '0.98em',
                              display: 'inline-block',
                              border: '1px solid #e2d2f0',
                            }}>{item.date}</span>
                          )}
                        </div>
                      )}
                      <ul style={{ margin: '4px 0 0 0', paddingLeft: 18, color: '#444', fontSize: '0.98em' }}>
                        {item.details.map((d, j) => (
                          <li key={j} style={{ marginBottom: 2 }}>{d}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    ))}
  </div>
);

const CV = () => (
  <>
    <Header />
    <main style={{ maxWidth: 900, margin: "40px auto 0 auto", padding: "2rem 1.5rem", fontFamily: 'Barlow, sans-serif', background: '#fff', borderRadius: 15, boxShadow: '0 2px 16px rgba(0,0,0,0.07)' }}>


      {/* Render Contact section with improved design */}
      {cvData[0].title === 'Contact' && (
        <section style={{ marginBottom: 40 }}>


          <div style={{
            background: 'linear-gradient(90deg, #fafdff 0%, #eaf6fa 100%)',
            borderRadius: 18,
            boxShadow: '0 2px 16px rgba(44,95,111,0.08)',
            padding: '32px 32px 24px 32px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            border: '1.5px solid #eaf6fa',
            maxWidth: 900,
            margin: '0 auto 40px auto',
          }}>
            {/* Download CV PDF button */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 18, gap: 16 }}>
              {/* Download button shadow effect on hover */}
              <style>{`
          .cv-download-btn, .cv-linkedin-btn {
            background: linear-gradient(90deg, #222222 0%, #222222 100%);
            color: #fff;
            font-weight: 700;
            padding: 10px 22px;
            border-radius: 8px;
            text-decoration: none;
            font-size: 1.08em;
            box-shadow: 0 2px 8px rgba(44,95,111,0.08);
            border: none;
            transition: box-shadow 0.18s, background 0.2s;
            letter-spacing: 0.5px;
            display: inline-block;
          }
          .cv-download-btn:hover, .cv-linkedin-btn:hover {
            box-shadow: 0 6px 24px rgba(44,95,111,0.18), 0 2px 8px rgba(44,95,111,0.08);
          }
        `}</style>
              {/* LinkedIn button removed; will render as a styled link below like GitHub */}
            </div>
            {/* Profile picture moved here from the Home page */}
            <img
              src="/data/about/images/me_autumn.jpg"
              alt="Portrait of Daphna Keidar"
              style={{
                width: 200,
                height: 200,
                borderRadius: '50%',
                objectFit: 'cover',
                boxShadow: '0 6px 24px rgba(169, 216, 227, 0.25)',
                marginBottom: 18,
              }}
            />
            <div style={{ fontSize: '2.2em', fontWeight: 800, color: '#2C5F6F', marginBottom: 6 }}>{cvData[0].items[0].title}</div>
            <div style={{ fontSize: '1.15em', color: '#2C5F6F', fontWeight: 500, marginBottom: 18 }}>{cvData[0].items[0].description}</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '18px 32px', justifyContent: 'center', marginBottom: 0 }}>
              {cvData[0].items[0].details?.map((d, i) => {
                if (d.includes('|')) {
                  const [label, url] = d.split('|');
                  return (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', fontSize: '1.08em', color: '#2C5F6F', background: '#fff', borderRadius: 8, padding: '7px 16px', boxShadow: '0 1px 4px rgba(44,95,111,0.06)', border: '1px solid #eaf6fa', fontWeight: 500 }}>
                      <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#2C5F6F', textDecoration: 'underline', fontWeight: 600 }}>{label}</a>
                    </div>
                  );
                }
                return (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', fontSize: '1.08em', color: '#2C5F6F', background: '#fff', borderRadius: 8, padding: '7px 16px', boxShadow: '0 1px 4px rgba(44,95,111,0.06)', border: '1px solid #eaf6fa', fontWeight: 500 }}>
                    {d}
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* Render sections with timeline as a connected vertical timeline */}
      <TimelineVertical sections={cvData.filter(s => s.timeline && s.timeline.length > 0)} />

      {/* Render all non-timeline, non-contact, non-skills sections except Publications */}
      {cvData.filter((s, idx) => (!s.timeline || s.timeline.length === 0) && idx !== 0 && s.title !== 'Skills' && s.title !== 'Publications').map((section, idx, arr) => {
        // Reduce gap if this is the Academic Projects section and the next section is Skills
        const isAcademicProjects = section.title.toLowerCase().includes('project');
        const nextIsSkills = arr[idx + 1] && arr[idx + 1].title === 'Skills';
        const marginBottom = isAcademicProjects && nextIsSkills ? 10 : 36;
        return (
          <section key={idx} style={{ marginBottom }}>
            <h2 style={{ fontSize: '1.5em', color: '#2C5F6F', marginBottom: 8 }}>{section.title}</h2>
            <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
              {section.items.map((item, i) => (
                <li key={i} style={{ marginBottom: 16 }}>
                  <div style={{ fontWeight: 600, fontSize: '1.1em' }}>{item.title}</div>
                  {/* Always show institution label for Academic Projects */}
                  {section.title.toLowerCase().includes('project') ? (
                    <div style={{ margin: '10px 0 6px 0', display: 'flex', gap: 10 }}>
                      {item.institution && (
                        <span style={{
                          background: '#eaf6fa',
                          color: '#2C5F6F',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #d2e7f0',
                        }}>{item.institution}</span>
                      )}
                      {item.location && (
                        <span style={{
                          background: '#eaf6fa',
                          color: '#2C5F6F',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #d2e7f0',
                        }}>{item.location}</span>
                      )}
                      {item.date && (
                        <span style={{
                          background: '#f5eafc',
                          color: '#7b3fa0',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #e2d2f0',
                        }}>{item.date}</span>
                      )}
                    </div>
                  ) : (item.institution || item.location || item.date) && (
                    <div style={{ margin: '10px 0 6px 0', display: 'flex', gap: 10 }}>
                      {item.institution && (
                        <span style={{
                          background: '#eaf6fa',
                          color: '#2C5F6F',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #d2e7f0',
                        }}>{item.institution}</span>
                      )}
                      {item.location && (
                        <span style={{
                          background: '#eaf6fa',
                          color: '#2C5F6F',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #d2e7f0',
                        }}>{item.location}</span>
                      )}
                      {item.date && (
                        <span style={{
                          background: '#f5eafc',
                          color: '#7b3fa0',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #e2d2f0',
                        }}>{item.date}</span>
                      )}
                    </div>
                  )}
                  {item.description && <div style={{ margin: '2px 0 2px 0', color: '#444' }}>{item.description}</div>}
                  {item.details && (
                    <ul style={{ margin: '4px 0 0 0', paddingLeft: 18, color: '#444', fontSize: '0.98em' }}>
                      {item.details.map((d, j) => (
                        <li key={j} style={{ marginBottom: 2 }}>{d}</li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
            <h2 style={{ fontSize: '1.5em', color: '#2C5F6F', marginBottom: 8 }}>{section.title}</h2>
            <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
              {section.items.map((item, i) => (
                <li key={i} style={{ marginBottom: 16 }}>
                  <div style={{ fontWeight: 600, fontSize: '1.1em' }}>{item.title}</div>
                  {/* Always show institution label for Academic Projects */}
                  {section.title.toLowerCase().includes('project') ? (
                    <div style={{ margin: '10px 0 6px 0', display: 'flex', gap: 10 }}>
                      {item.institution && (
                        <span style={{
                          background: '#eaf6fa',
                          color: '#2C5F6F',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #d2e7f0',
                        }}>{item.institution}</span>
                      )}
                      {item.location && (
                        <span style={{
                          background: '#eaf6fa',
                          color: '#2C5F6F',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #d2e7f0',
                        }}>{item.location}</span>
                      )}
                      {item.date && (
                        <span style={{
                          background: '#f5eafc',
                          color: '#7b3fa0',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #e2d2f0',
                        }}>{item.date}</span>
                      )}
                    </div>
                  ) : (item.institution || item.location || item.date) && (
                    <div style={{ margin: '10px 0 6px 0', display: 'flex', gap: 10 }}>
                      {item.institution && (
                        <span style={{
                          background: '#eaf6fa',
                          color: '#2C5F6F',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #d2e7f0',
                        }}>{item.institution}</span>
                      )}
                      {item.location && (
                        <span style={{
                          background: '#eaf6fa',
                          color: '#2C5F6F',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #d2e7f0',
                        }}>{item.location}</span>
                      )}
                      {item.date && (
                        <span style={{
                          background: '#f5eafc',
                          color: '#7b3fa0',
                          borderRadius: 14,
                          padding: '2px 12px',
                          fontWeight: 600,
                          fontSize: '0.98em',
                          display: 'inline-block',
                          border: '1px solid #e2d2f0',
                        }}>{item.date}</span>
                      )}
                    </div>
                  )}
                  {item.description && <div style={{ margin: '2px 0 2px 0', color: '#444' }}>{item.description}</div>}
                  {item.details && (
                    <ul style={{ margin: '4px 0 0 0', paddingLeft: 18, color: '#444', fontSize: '0.98em' }}>
                      {item.details.map((d, j) => (
                        <li key={j} style={{ marginBottom: 2 }}>{d}</li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </section>
        );
      })}

      {/* Render Skills section with improved design just before Publications */}
      {cvData.find(s => s.title === 'Skills') && (
        <section style={{ marginBottom: 40, marginTop: -50 }}>
          <div style={{
            background: 'linear-gradient(90deg, #fafdff 0%, #eaf6fa 100%)',
            borderRadius: 16,
            boxShadow: '0 2px 12px rgba(44,95,111,0.06)',
            padding: '28px 32px 20px 32px',
            maxWidth: 900,
            margin: '0 auto 36px auto',
            border: '1.5px solid #eaf6fa',
          }}>
            <h2 style={{ fontSize: '1.5em', color: '#2C5F6F', marginBottom: 18, textAlign: 'center', fontWeight: 700, letterSpacing: 0.5 }}>Skills</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: 18, columnGap: 32 }}>
              {cvData.find(s => s.title === 'Skills')!.items.map((item, i, arr) => {
                // Reduce marginTop for AI Research (or similar) to bring it closer to the above
                const isAIResearch = item.title.toLowerCase().includes('ai research');
                const marginTop = isAIResearch ? 4 : 0;
                return (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginTop }}>
                    <div>
                      <div style={{ fontWeight: 600, color: '#2C5F6F', marginBottom: 2 }}>{item.title}</div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '7px 10px' }}>
                        {item.description?.split(',').map((skill, j) => (
                          <span key={j} style={{ background: '#eaf6fa', color: '#2C5F6F', borderRadius: 6, padding: '3px 10px', fontSize: '0.98em', fontWeight: 500, marginBottom: 2 }}>{skill.trim()}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* Render Publications section last with bullet style like upper sections */}
      {cvData.find(s => s.title === 'Publications') && (
        <section style={{ marginBottom: 36 }}>
          <h2 style={{ fontSize: '1.5em', color: '#2C5F6F', marginBottom: 8 }}>Publications</h2>
          <ul style={{ paddingLeft: 18, color: '#444', fontSize: '1em', lineHeight: 1.6, listStyle: 'disc' }}>
            {cvData.find(s => s.title === 'Publications')!.items.map((item, i) => (
              <li key={i} style={{ marginBottom: 14 }}>
                <span style={{ fontWeight: 700, color: '#2C5F6F' }}>{item.title}</span>
                {item.details && (
                  <ul style={{ margin: '4px 0 0 0', paddingLeft: 18, color: '#444', fontSize: '0.98em', listStyle: 'circle' }}>
                    {item.details.map((d, j) => (
                      <li key={j} style={{ marginBottom: 2 }}>{d}</li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </section>
      )}
    </main>
    <Footer />
  </>
);

export default CV;
